import "core-js/modules/es.array.iterator";
import "core-js/modules/es.promise";

import GLightbox from "glightbox";

let common = require('./common');

common.init();

let el = document.getElementById('slider');

if (el) {
    import(
        /* webpackChunkName: "swiper" */
        'swiper').then(function (module) {
        let slider = new module.default('#slider', {
            loop: true,
            lazy: true,
            slidesPerView: 4,
            spaceBetween: 30,
            watchSlidesVisibility: true,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            breakpoints: {
                767: {
                    slidesPerView: 2,
                    spaceBetween: 10,
                    centeredSlides: true,
                    navigation: false
                },
                979: {
                    slidesPerView: 3,
                    spaceBetween: 15,
                },
                1217: {
                    slidesPerView: 4,
                    spaceBetween: 15,
                }
            }
        });

        new GLightbox({
            selector: 'lightbox'
        });
    }, function (e) {
        console.log('Unable to load swiper library' + e.message);
        throw new Error('Unable to load swiper library' + e.message);
    });
}
